import { v4 as uuid } from 'uuid';

/**
 * Not using atlassiansox/origin-tracing because it adds a lot of unnecessary
 * bloat to every bundle that has an upsell, which is a lot of them.
 *
 * @description
 * Create shorthand encoded origin object:
 * - p: `t` is shorthand for 'product': `trello`
 * - i: `id` is just a uuid with hyphens removed to save bytes
 *
 * Stringify and base64 encode the origin object, then do some URL-safe
 * character replacements and add it to the given url as `atlOrigin` query param
 *
 * @see https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/browse/platform/packages/growth/origin-tracing/src/encoder.ts#13
 * @see https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/browse/platform/packages/growth/origin-tracing/src/util/base64url.ts#12
 */
export const getAtlOrigin = (): string => {
  return btoa(JSON.stringify({ i: uuid().replace('-', ''), p: 't' }))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=/g, '');
};
